var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tabs',{on:{"change":_vm.callback}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"谷歌注册信息"}},[_c('Google')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"FB注册信息"}},[_c('Facebook')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }